import React from 'react';
import QuestionPanel from "../../structure/QuestionPanel";
import AddListElementButton from "../../button/AddListElementButton";
import LifeBenefit from "../../input/LifeBenefit";

const LifeBenefits = () => {
    return (
        <QuestionPanel headerText="Please fill in the dollar amount for each benefit that applies."
                       panelContent={
                           <AddListElementButton idPrefix="benefits"
                                                 buttonText="Add Benefit"
                                                 componentType={LifeBenefit}
                                                 elementInitialValue={{
                                                     claimed: '',
                                                     amount: ''
                                                 }}/>
                       }
        />
    )
};
export default LifeBenefits;